/* MERRY VELA - Mystery Gift keeper.
   - Santa Paws hoodie, LED Light Curtain and heated robe: with 2+ of that product in the cart, adds exactly 1 free Mystery Gift line (0.00); removes it when fewer than 2 qualifying items remain.
   - Memory Orb: only removes the gift when fewer than 2 Orbs/hoodies/curtains/robes qualify (EasyGift adds it for Orbs).
   - Never lets more than 1 Mystery Gift unit stay in the cart. */
(function () {
  'use strict';
  var cfg = window.mvGiftGuard;
  if (!cfg || !window.fetch) return;

  var GIFT = Number(cfg.giftProductId);
  var GIFT_VARIANT = Number(cfg.giftVariantId);
  var ORB = Number(cfg.orbProductId);
  var HOODIE = Number(cfg.hoodieProductId);
  var LED = Number(cfg.ledProductId);
  var ROBE = Number(cfg.robeProductId) || 16012563120511;
  var MIN = Number(cfg.minQty) || 2;
  var routes = (window.theme && window.theme.routes) || {};
  var cartUrl = routes.cart || '/cart';
  var nativeFetch = window.fetch.bind(window);
  var running = false;
  var queued = false;
  var timer = null;
  var addFailures = 0;

  function getCart() {
    return nativeFetch(cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('mystery-gift cart');
        return r.json();
      });
  }

  function changeLine(key, qty) {
    return nativeFetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      if (!r.ok) throw new Error('mystery-gift change');
      return r.json();
    });
  }

  function addGift() {
    return nativeFetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: GIFT_VARIANT, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('mystery-gift add');
      return r.json();
    });
  }

  function reconcile() {
    return getCart().then(function (cart) {
      var orbQty = 0;
      var hoodieQty = 0;
      var ledQty = 0;
      var robeQty = 0;
      var gifts = [];
      cart.items.forEach(function (it) {
        if (it.product_id === GIFT) gifts.push(it);
        else if (it.product_id === ORB) orbQty += it.quantity;
        else if (it.product_id === HOODIE) hoodieQty += it.quantity;
        else if (LED && it.product_id === LED) ledQty += it.quantity;
        else if (ROBE && it.product_id === ROBE) robeQty += it.quantity;
      });
      var qualifying = orbQty + hoodieQty + ledQty + robeQty;
      var chain = Promise.resolve(false);
      function step(fn) { chain = chain.then(function () { return fn().then(function () { return true; }); }); }

      if (qualifying < MIN) {
        gifts.forEach(function (g) { step(function () { return changeLine(g.key, 0); }); });
        return chain;
      }
      if (gifts.length === 0) {
        if ((hoodieQty >= MIN || ledQty >= MIN || robeQty >= MIN) && GIFT_VARIANT && addFailures < 3) {
          step(function () { return addGift().catch(function (e) { addFailures += 1; throw e; }); });
        }
        return chain;
      }
      gifts.forEach(function (g, i) {
        if (i > 0) step(function () { return changeLine(g.key, 0); });
        else if (g.quantity > 1) step(function () { return changeLine(g.key, 1); });
      });
      return chain;
    });
  }

  function onCartPage() {
    var p = window.location.pathname;
    if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
    return p === cartUrl;
  }

  function sync() {
    if (running) { queued = true; return; }
    running = true;
    reconcile().then(function (changed) {
      if (!changed) return;
      if (onCartPage()) { window.location.reload(); return; }
      var M = window.MerryVela;
      if (M && M.Cart && M.Cart.refresh) M.Cart.refresh();
    }).catch(function () { /* never block shopping */ }).then(function () {
      running = false;
      if (queued) { queued = false; schedule(); }
    });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(sync, delay == null ? 400 : delay);
  }

  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (u.indexOf('/cart/add') > -1 || u.indexOf('/cart/change') > -1 || u.indexOf('/cart/update') > -1 || u.indexOf('/cart/clear') > -1) {
        p.then(function () { schedule(); }, function () {});
      }
    } catch (e) { /* ignore */ }
    return p;
  };

  function start() {
    if (onCartPage() || document.cookie.indexOf('cart=') > -1) schedule(0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('pageshow', function (e) { if (e.persisted) start(); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') start(); });
})();
